import { createSelector } from 'reselect';

import type { RootState } from '../store';

const selectDomain = (state: RootState) => state.component;

export const selectCurrentStep = createSelector(selectDomain, (state) => state.currentStep);
